__webpack_require__.p = "/collector-configurator/";